import React from 'react';
import { getStatusSeverity } from '../../../utils/statusSeverity';
import styles from './StatusBadge.module.css';

export default function StatusBadge({ status, label, variant }) {
  const resolvedVariant = variant || getStatusSeverity(status);
  const displayLabel = label || (status ? status.replace(/_/g, ' ') : '');

  return (
    <span className={`${styles.badge} ${styles[resolvedVariant]}`}>
      {displayLabel}
    </span>
  );
}
